import { render, staticRenderFns } from "./Bankscbonly.vue?vue&type=template&id=542a5a42"
import script from "./Bankscbonly.vue?vue&type=script&lang=js"
export * from "./Bankscbonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports